import React from "react";
import { ITheme } from "./theme";
import preflight from "./preflight";
import { css, Global } from "@emotion/react";

const buildDefaultConfig = (theme: ITheme) => ({
  light: {
    color: theme.colors.gray[800],
    bg: undefined,
    borderColor: theme.colors.gray[200],
    placeholderColor: theme.colors.gray[400],
  },
  dark: {
    color: theme.colors.whiteAlpha[900],
    bg: theme.colors.gray[800],
    borderColor: theme.colors.whiteAlpha[300],
    placeholderColor: theme.colors.whiteAlpha[400],
  },
});

interface ICSSResetProps {
  buildConfig?: (theme: ITheme, defaultConfig?: any) => any;
}

const CSSReset: React.FC<ICSSResetProps> = ({ buildConfig }: ICSSResetProps) => {
  const colorMode = "light";

  const configCSS = (theme: ITheme) => {
    const defaultConfig = buildDefaultConfig(theme);
    const config = buildConfig ? buildConfig(theme, defaultConfig) : buildDefaultConfig(theme);
    const { color, bg, borderColor, placeholderColor } = config[colorMode];

    return css`
      html {
        line-height: 1.333;
        color: ${color};
        background-color: ${bg};
      }

      /**
      * Allow adding a border to an element by just adding a border-width.
      */

      *,
      *::before,
      *::after {
        border-width: 0;
        border-style: solid;
        border-color: ${borderColor};
      }

      input:-ms-input-placeholder,
      textarea:-ms-input-placeholder {
        color: ${placeholderColor};
      }

      input::-ms-input-placeholder,
      textarea::-ms-input-placeholder {
        color: ${placeholderColor};
      }

      input::placeholder,
      textarea::placeholder {
        color: ${placeholderColor};
      }
    `;
  };

  return <Global styles={(theme: any) => css([preflight(theme), configCSS(theme)])} />;
};

export default CSSReset;
